<template lang="pug">
v-fade-transition(mode="in-out" class="tw-p-0 tw-m-0")
  v-container(fluid fill-height class="tw-p-0 tw-h-screen tw-overflow-hidden")
    v-row(align="center" justify="space-between")
      v-col(cols="6" class="hidden-sm-and-down")
        v-card(tile :img="image" class="tw-h-screen tw-p-0 tw-m-0 tw-border-0")
      v-col(lg="6" cols="12" class="")
        v-row(no-gutters fill-height align="center" justify="center")
          v-col(lg="12" xl="8" cols="10")
            v-row(no-gutters align="center" justify="center")
              v-col(cols="auto")
                v-img(src="@/assets/images/kubiqa-logo.svg" width="300px" class="py-0")
            v-row(no-gutters align="center" justify="center")
              v-col(class="text-center")
                v-stepper(v-model="stepper" flat elevation="0" class="tw-mt-10")
                  v-stepper-items
                    v-stepper-content(step="1" class="")
                      v-card(height="450px")
                        v-row(no-gutters)
                          v-col
                            div(class="tw-text-xl tw-font-bold tw-mb-2 tw-leading-tight") {{ $t('Website.Common.registerHeadline') }}
                            div(class="tw-text-base tw-mb-5 tw-italic tw-leading-snug") {{ $t('Website.Common.registerSubheadline') }}
                            div(v-if="earlyAccess" class="tw-mb-5 tw-rounded tw-bg-blue-50 tw-p-3 tw-text-blue-900" role="status")
                              div(class="tw-font-bold") You’re joining Kubiqa Early Access.
                              div(class="tw-mt-2 tw-leading-relaxed") No credit card is required. Kubiqa is free during the Early Access period.
                            v-btn(
                              v-if="!invitation"
                              outlined
                              rounded
                              aria-label="Continue with Google"
                              @click="beginGoogleSignIn"
                              class="tw-mb-5"
                            )
                              span Continue with Google
                        v-form(
                          ref="formStep1"
                          v-model="valid"
                          lazy-validation
                          @keyup.native.enter="continueFromEmailStep"
                          v-on:submit.prevent=""
                        )
                          v-row(class="")
                            v-col
                              v-text-field(
                                v-model="name"
                                ref="name"
                                :rules="nameRules"
                                :label="$t('Common.name')"
                                color="blue darken-4"
                                required
                              )
                            v-col
                              v-text-field(
                                v-model="lastName"
                                ref="lastName"
                                :rules="nameRules"
                                :label="$t('Contacts.Common.lastName')"
                                color="blue darken-4"
                                required
                              )
                          v-row
                            v-col
                              v-text-field(
                                v-model="email"
                                ref="email"
                                :rules="emailRules"
                                :label="$t('Common.email')"
                                color="blue darken-4"
                                required
                                class=""
                                @input="emailAlreadyRegistered = false"
                              )
                              div(
                                v-if="emailAlreadyRegistered"
                                role="alert"
                                class="tw-mt-2 tw-text-sm tw-text-red-700"
                              )
                                span {{ $t('Website.Common.emailAlreadyRegistered') }}
                                router-link(
                                  :to="{ path: '/login' }"
                                  class="tw-ml-1 tw-font-bold tw-text-blue-700 tw-underline"
                                ) {{ $t('Website.Common.loginWithExistingEmail') }}
                          v-row
                            v-col
                              v-btn(
                                color="rgba(94,129,244)"
                                elevation="0"
                                rounded
                                :loading="checkingEmail"
                                :disabled="checkingEmail"
                                @click="continueFromEmailStep"
                                class=" tw-w-2/3 "
                              )
                                span(class="tw-font-bold tw-uppercase") {{ $t('Common.register') }}
                    v-stepper-content(step="2")
                      v-card(height="450px")
                        v-form(
                          ref="formStep2"
                          v-model="valid"
                          lazy-validation
                          @keyup.native.enter="$refs.formStep2.validate() && invitation ? register : $refs.formStep2.validate() && !invitation ? stepper++ : null"
                          v-on:submit.prevent=""
                        )
                          v-row(no-gutters)
                            v-col
                              div(class="tw-text-xl tw-font-bold tw-mb-2 tw-leading-tight") {{ $t('Website.Common.addPasswordHeadline') }}
                              div(class="tw-text-base tw-mb-1 tw-italic tw-leading-snug") {{ $t('Website.Common.addPasswordSubheadline') }}
                          v-row(no-gutters)
                            v-col
                              v-text-field(
                                v-model="password"
                                :rules="passwordRules"
                                :type="'password'"
                                name="input-10-1"
                                :label="$t('Common.password')"
                                color="blue darken-4"
                                required
                              )
                              v-text-field(
                                v-model="passwordConfirm"
                                :rules="passwordConfirmRules"
                                :type="'password'"
                                name="input-10-1"
                                :label="$t('Profile.Common.confirmPassword')"
                                color="blue darken-4"
                                required
                              )
                          v-row(align="center" justify="end")
                            v-col(cols="auto")
                              v-btn(
                                v-if="!invitation"
                                color="rgba(94,129,244)"
                                elevation="0"
                                width="150px"
                                @click="$refs.formStep2.validate() ? stepper++ : null"
                                class=" tw-w-2/3 "
                              )
                                span(class="tw-font-bold tw-uppercase") {{ $t('Common.next') }}
                              v-btn(
                                v-else
                                color="rgba(94,129,244)"
                                elevation="0"
                                width="150px"
                                @click="$refs.formStep2.validate() ? register : null"
                                class=" tw-w-2/3 "
                              )
                                span(class="tw-font-bold tw-uppercase") {{ $t('Common.register') }}
                    v-stepper-content(step="3" v-if="!invitation")
                      v-card(height="450px")
                        v-form(
                          ref="formStep3"
                          v-model="valid"
                          lazy-validation
                          @keyup.native.enter="$refs.formStep3.validate() ? register : null"
                          v-on:submit.prevent="register"
                        )
                          v-row(no-gutters)
                            v-col
                              div(class="tw-text-xl tw-font-bold tw-mb-2 tw-leading-tight") {{ $t('Website.Common.addCompanyNameHeadline') }}
                              div(class="tw-text-base tw-mb-1 tw-italic tw-leading-snug") {{ $t('Website.Common.addCompanyNameSubheadline') }}
                          v-row
                            v-col
                              v-text-field(
                                v-model="company"
                                ref="company"
                                :rules="companyRules"
                                :label="$t('Settings.Common.companyName')"
                                color="blue darken-4"
                                required
                              )
                          v-row(align="center" justify="end")
                            v-col(cols="auto")
                              v-btn(
                                v-if="verify"
                                color="rgba(94,129,244)"
                                elevation="0"
                                width="150px"
                                @click="$refs.formStep3.validate() ? register : null"
                                class=" tw-w-2/3 "
                              )
                                span(class="tw-font-bold tw-uppercase") {{ $t('Common.next') }}
                              v-btn(
                                v-else
                                color="rgba(94,129,244)"
                                elevation="0"
                                width="150px"
                                :loading="loading"
                                @click="register"
                                class=" tw-w-2/3 "
                              )
                                span(class="tw-font-bold tw-uppercase") {{ $t('Common.register') }}
                    v-stepper-content(step="4" v-if="!invitation")
                      v-card(height="300px")
                        v-form(
                          ref="formStep4"
                          v-model="valid"
                          lazy-validation
                          @keyup.native.enter="$refs.formStep4.validate() ? stepper++ : null"
                        )
                          v-row
                            v-col
                              div(class="tw-pb-2")
                                span(class="tw-text-xl tw-font-bold tw-mb-2 tw-leading-tight") {{ $t('Website.Common.confirmEmailHeadline') }}
                              div
                                span(class="tw-text-base tw-mb-5 tw-italic tw-leading-snug") {{ $t('Website.Common.confirmEmailSubheadline') }}
                    //- v-stepper-content(step="5" v-if="!invitation && verify")
                    //-   v-card(height="500px")
                    //-     v-form(
                    //-       ref="formStep4"
                    //-       v-model="valid"
                    //-       lazy-validation
                    //-       @keyup.native.enter="$refs.formStep4.validate() ? stepper++ : null"
                    //-     )
                    //-       v-row
                    //-         v-col
                    //-           div(class="tw-pb-2")
                    //-             span(class="tw-text-xl tw-font-bold tw-mb-2 tw-leading-tight") {{ $t('Website.Common.confirmEmailSuccessHeadline') }}
                    //-           div
                    //-             span(class="tw-text-base tw-mb-5 tw-italic tw-leading-snug") {{ $t('Website.Common.confirmEmailSuccessSubheadline') }}
                    //-           div
                    //-             kubiqa-misc-pricing-grid(layout="register")

        // Error snackbar
        v-row
          v-snackbar(v-model="error" color="error")
            span {{ this.error_message }}
</template>

<script>
import AuthService from '@/services/AuthService';
import { buildRegistrationPayload, isEarlyAccessRegistration, trackSignupEvent } from '@/features/early-access';
import { googleAuthorizationUrl } from '@/features/google-oauth';
export default {
  name: 'Register',
  data() {
    return {
      stepper: 1,
      valid: false,
      error: false,
      loading: false,
      checkingEmail: false,
      error_message: '',
      emailAlreadyRegistered: false,
      password: '',
      passwordConfirm: '',
      verificationCode: '',
      email: '',
      name: '',
      lastName: '',
      company: '',
      image: require('@/assets/images/auth/real-estate-login.jpg'),
      verificationCodeRules: [
        //(v) => !!v || 'Please enter your verification code',
        //(v) => !v || /^\d{6}$/.test(v) || 'Verification code must be 6 digits',
      ],
      passwordRules: [
        //(v) => !v || 'Please enter your password',
        (v) =>
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{16,}$/.test(v) ||
          'Min. 16 characters with at least one uppercase letter, one lowercase letter, one number, and one special character',
      ],
      passwordConfirmRules: [(v) => this.password === this.passwordConfirm || 'Passwords must match'],
      emailRules: [
        (v) => !!v || 'Please enter your email',
        (v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
      ],
      nameRules: [
        //(v) => !!v || 'Please enter your full name'
      ],
      companyRules: [(v) => !!v || 'Company name is required'],
    };
  },
  computed: {
    invitation() {
      return this.$route.params.invitation;
    },
    earlyAccess() {
      return isEarlyAccessRegistration(this.$route);
    },
    verify() {
      // return true;
      return this.$route.params.verify;
    },
  },
  methods: {
    async continueFromEmailStep() {
      if (this.checkingEmail || !this.$refs.formStep1.validate()) {
        return;
      }

      if (this.invitation) {
        this.stepper++;
        return;
      }

      const email = this.email.trim();
      this.emailAlreadyRegistered = false;
      this.checkingEmail = true;

      try {
        const response = await AuthService.checkEmailAvailability({ email });
        if (email !== this.email.trim()) {
          return;
        }

        if (response.data.available === false) {
          this.emailAlreadyRegistered = true;
          return;
        }

        if (response.data.available !== true) {
          throw new Error('Unexpected email availability response');
        }

        this.stepper++;
      } catch (error) {
        if (email === this.email.trim()) {
          this.error_message = this.$t('Website.Common.emailAvailabilityCheckFailed');
          this.error = true;
        }
      } finally {
        this.checkingEmail = false;
      }
    },
    isDuplicateEmailError(error) {
      const response = error && error.response && error.response.data;
      const emailErrors = response && response.errors && response.errors.email;
      const messages = Array.isArray(emailErrors) ? emailErrors : [response && response.message];

      return messages.some((message) =>
        typeof message === 'string' &&
          /already\s+(?:been\s+)?(?:taken|registered|used|exists)|(?:email|account).*already\s+exists/i.test(message)
      );
    },
    beginGoogleSignIn() {
      const authorizationUrl = googleAuthorizationUrl();

      if (!authorizationUrl) {
        this.error_message = 'Google sign-in is temporarily unavailable. Please register with a password.';
        this.error = true;
        return;
      }

      window.location.assign(authorizationUrl);
    },
    // validate() {
    //   if (this.$refs.form.validate()) {
    //     this.error = true;
    //     this.error_message = 'error';
    //   }
    // },
    // reset() {
    //   this.$refs.form.reset();
    // },
    // resetValidation() {
    //   this.$refs.form.resetValidation();
    // },
    register() {
      this.error = null;
      this.loading = true;
      const invitation = this.$route.params.invitation;
      const earlyAccess = isEarlyAccessRegistration(this.$route);
      const payload = buildRegistrationPayload(
        {
          email: this.email,
          password: this.password,
          name: this.name,
          lastName: this.lastName,
        },
        this.$route
      );
      if (invitation) {
        payload.invitation = invitation;
      }
      if (this.company) {
        payload.company = this.company;
      }
      trackSignupEvent(this.$ga, 'started', earlyAccess);
      AuthService.registerUser(payload)
        .then(() => {
          this.loading = false;
          trackSignupEvent(this.$ga, 'completed', earlyAccess);
          if (invitation) {
            this.$router.push({ path: '/dashboard' });
          } else {
            this.stepper = 4;
          }
        })
        .catch((error) => {
          this.loading = false;
          if (!invitation && this.isDuplicateEmailError(error)) {
            this.emailAlreadyRegistered = true;
            this.stepper = 1;
            this.$store.commit('SET_ERROR', null);
            return;
          }
          this.error_message = error;
        });
    },
  },
};
</script>
